import { Component, Input } from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import { getPermissionEnumKey, LorenzFormControl, LorenzFormElement, PermissionEnum } from '@lib/forms';
import { AppEnvironmentEnum } from '@lib/shared';

@Component({
	selector: 'lib-form-validity-dot',
	imports: [CommonModule, NgClass],
	templateUrl: './lib-form-validity-dot.component.html',
	styleUrls: ['./lib-form-validity-dot.component.scss']
})
export class LibFormValidityDotComponent {
	protected readonly AppEnvironmentEnum = AppEnvironmentEnum;

	@Input({ required: true, alias: 'control' }) lorenzFormElement: LorenzFormElement | null = null;

	private allowedEnvironments = [AppEnvironmentEnum.LOCAL, AppEnvironmentEnum.DEV];

	get isVisible(): boolean {
		return (this.lorenzFormElement && this.allowedEnvironments.includes(this.lorenzFormElement.getAppEnvironment())) ?? false;
	}

	onLeftClick(event: MouseEvent): void {
		if (!this.lorenzFormElement) {
			return;
		}

		event.preventDefault();

		console.log('CONTROL', this.lorenzFormElement.getFullKey(), this.lorenzFormElement);

		if (this.lorenzFormElement.invalid) {
			console.log('Validation errors', this.findInvalidControls(this.lorenzFormElement));
		}
	}

	onRightClick(event: MouseEvent): void {
		if (!this.lorenzFormElement) {
			return;
		}

		event.preventDefault();

		console.log('CONTROL Value', this.lorenzFormElement.getFullKey(), this.lorenzFormElement.getRawValue());
		console.log('CONTROL ValueBuffer', this.lorenzFormElement.getFullKey(), this.lorenzFormElement.getValueBuffer());
	}

	findInvalidControls(element: LorenzFormElement): string[] {
		let invalidControlKeys: string[] = [];
		if (element instanceof LorenzFormControl) {
			if (element.invalid) {
				invalidControlKeys.push(element.getFullKey());
			}
		} else if (element.controls) {
			Object.values(element.controls).forEach((childControl) => {
				invalidControlKeys = invalidControlKeys.concat(this.findInvalidControls(childControl as LorenzFormElement));
			});
		}

		return invalidControlKeys;
	}

	getTitle() {
		// prettier-ignore
		return [
			this.lorenzFormElement?.valid ? 'VALID' : 'INVALID',
			this.lorenzFormElement?.isEnabled() ? 'ENABLED' : 'DISABLED',
			this.lorenzFormElement?.isReadonly() ? 'READONLY' : 'EDITABLE',
			this.lorenzFormElement?.isLocked() ? 'LOCKED' : 'UNLOCKED',
			this.lorenzFormElement?.touched ? 'TOUCHED' : 'UNTOUCHED',
			getPermissionEnumKey(this.lorenzFormElement?.getPermission() ?? PermissionEnum.NONE),
			this.lorenzFormElement?.getFullKey()
		].join(' | ');
	}

	// logFormStructure(element: LorenzFormElement, indent: number = 0): void {
	// 	const padding = ' '.repeat(indent * 4);
	// 	if (element instanceof LorenzFormControl) {
	// 		// console.log(`${padding}  ${element.getKey()}: ${this.getControlType(element)} => ${element.value}`);
	// 	} else if (element instanceof LorenzFormGroup) {
	// 		Object.keys(element.controls).forEach((key) => {
	// 			const childControl = element.get(key) as any;
	// 			if (childControl) {
	// 				console.log(`${padding}  ${key}: ${childControl.getControlType(childControl)} => ${childControl.value}`);
	// 				this.logFormStructure(childControl, indent + 1);
	// 			}
	// 		});
	// 	} else {
	// 		element.controls.forEach((item, index) => {
	// 			// console.log(`${padding}  [${index}]: ${this.getControlType(ctrl)} => ${ctrl.value}`);
	// 			console.log(`${padding}  [${index}]: ${(item as any).getControlType()} => ${item.value}`);
	// 			this.logFormStructure(item as any, indent + 1);
	// 		});
	// 	}
	// }
	//
	// getControlType(control: AbstractControl): string {
	// 	if (control instanceof FormControl) {
	// 		return 'FormControl';
	// 	} else if (control instanceof FormGroup) {
	// 		return 'FormGroup';
	// 	} else if (control instanceof FormArray) {
	// 		return 'FormArray';
	// 	} else {
	// 		return 'Unknown';
	// 	}
	// }
}
